import { create } from "zustand";
import { useFetchBusinessPlanningSlice } from "../slices/BusinessPlanningSlices/getBusinessTemplate";

interface BusinessPlanningInterface
  extends ReturnType<typeof useFetchBusinessPlanningSlice> {}

export const BusinessPlanningStore = create<BusinessPlanningInterface>((...data) => ({
  ...useFetchBusinessPlanningSlice(...data),
}));
